import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CollaborationTab = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 18 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3007 13.5072L3.82237 14.1199L2.74191 15.5039H7.67347L7.66924 15.4927H9.11628L9.1188 15.4927H9.12066C12.8165 15.4927 15.8125 12.4966 15.8125 8.80082C15.8125 5.105 12.8165 2.10895 9.12066 2.10895C5.42484 2.10895 2.42878 5.105 2.42878 8.80082C2.42878 10.3432 2.94935 11.7611 3.82495 12.8925L4.3007 13.5072ZM9.11628 16.5039H9.08672H8.05145H1.71724C1.30074 16.5039 1.06682 16.0245 1.32312 15.6962L3.03413 13.5045C2.02771 12.2041 1.42878 10.5724 1.42878 8.80082C1.42878 4.55272 4.87255 1.10895 9.12066 1.10895C13.3688 1.10895 16.8125 4.55272 16.8125 8.80082C16.8125 12.6968 13.9161 15.9162 10.1591 16.4232C9.82897 16.4677 9.49222 16.4914 9.15021 16.4926L9.12066 16.4927H9.12051L9.11628 16.4927L9.12051 16.5039H9.11628ZM5.99756 10.666C5.99756 10.3898 6.22142 10.166 6.49756 10.166H11.5942C11.8703 10.166 12.0942 10.3898 12.0942 10.666C12.0942 10.9421 11.8703 11.166 11.5942 11.166H6.49756C6.22142 11.166 5.99756 10.9421 5.99756 10.666ZM6.48389 7.13434C6.20774 7.13434 5.98389 7.3582 5.98389 7.63434C5.98389 7.91048 6.20774 8.13434 6.48389 8.13434H11.5805C11.8566 8.13434 12.0805 7.91048 12.0805 7.63434C12.0805 7.3582 11.8566 7.13434 11.5805 7.13434H6.48389Z"
        />
      </svg>
    )
  },
)

export default CollaborationTab
